import { render, staticRenderFns } from "./Motorbike.vue?vue&type=template&id=1bd163a5&scoped=true&"
import script from "./Motorbike.vue?vue&type=script&lang=js&"
export * from "./Motorbike.vue?vue&type=script&lang=js&"
import style0 from "./Motorbike.vue?vue&type=style&index=0&id=1bd163a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd163a5",
  null
  
)

export default component.exports